import ACTIONS from "../actions/types";
// import moment from "moment";

const initialState = {};

const dashboardReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.ALERT.FIRE_ERROR_ALERT:
      return {
        ...state,
        message: payload.message,
        options: payload.options
      };
    case ACTIONS.ALERT.END_ERROR_ALERT:
      return {
        ...state,
        message: "",
        options: {}
      };

    default:
      return { ...state };
  }
};
export default dashboardReducer;
